<template>
<v-container>
<v-card elevation="11" class=" pa-2" color="secondary" light>
  <v-card-title class="d-flex justify-center font-weight-black text-h3 textTitle--text">{{ $t('modifcat.screenTitle') }}</v-card-title>
  <v-card color="quaterny" class="ma-1 pa-3">
             <v-row class="justify-center align-center">
    <h2 class="font-weight-bold underline text-decoration-underline ma-5 pa-4">{{ $t('catmanager.catName') }}</h2>
    <v-text-field v-model="cat[0].name" background-color="quinty" height="60px" color="primary"  rounded class="font-weight-black text-h6 ma-5 pa-4 shrink"></v-text-field>
  </v-row>
  <v-divider></v-divider>
  <v-row class="justify-center align-center">
    <h2 class="font-weight-bold underline text-decoration-underline ma-5 pa-4">{{ $t('catmanager.catDesc') }}</h2>
    <v-textarea v-model="cat[0].desc" auto-grow background-color="quinty" color="primary" rounded class="font-weight-black text-h6 ma-5 pa-4 shrink"></v-textarea>
  </v-row>
            <v-divider></v-divider>
            <v-row class="ma-5 align-center justify-center"><h2 class="ma-2">{{ $t('catmanager.catInvalert') }}</h2>
            <div class="ma-2" width="30%"><v-text-field max=100 min=0 class="font-weight-black text-h5 textMenu--text" type="number" background-color="quinty" filled v-model.number="cat[0].invAlert"></v-text-field></div>
            </v-row>
  </v-card>
 
  <v-row class="justify-center">
    <v-btn class="ma-5 pa-5 textMenu black--text font-weight-black" X-large rounded elevation="11" @click="makeCatPrincipal">{{ $t('modifcat.makeMaincatButton') }}</v-btn>
     </v-row>

  <v-row align="center" class="primary">
    <v-col cols="5">
      <v-row justify="center" align="center">
         <h2 class="text-center textTitle--text font-weight-black ma-5">{{ $t('modifcat.currentCat') }}</h2>
       </v-row>
       <v-row justify="center" align="center">
         <v-col cols="12">
         <v-treeview
                    :items="treeviewCatItems"
                    :active="[cat[0].id]"
                    open-all
                    class="secondary textTitle--text font-weight-black mx-8"
                    active-class="textMenu font-weight-black black--text"
                    expand-icon="mdi-chevron-right secondary quinty--text"
                >
                
                </v-treeview>
                </v-col>
       </v-row>
      
      
    </v-col>
     <v-col cols="2">
       
      <h3 class="text-center quinty--text">{{ $t('modifcat.changeCatMessage') }}</h3>
     
        </v-col>
     <v-col cols="5">
       <v-row justify="center" align="center">
         <h2 class="text-center textTitle--text font-weight-black ma-5">{{ $t('modifcat.newCat') }}</h2>
       </v-row>
       <v-row justify="center" align="center">
         <v-col cols="12">
         <v-treeview
                    :items="treeviewCatItems"
                    open-all
                    class="secondary textTitle--text font-weight-black mx-8"
                    expand-icon="mdi-chevron-right secondary quinty--text"
                    hoverable
                >
                <template v-slot:label="{ item }">
              <v-row align="center" >
              <h3 class="ma-3 pa-3">{{item.name}}</h3>
              <v-btn v-if="item.id!='uncategorized'" @click="changeParent(item)" small class="font-weight-black black--text ma-3 pa-3 ml-8" color="textMenu">{{ $t('modifcat.moveCatButton') }}</v-btn>
            </v-row>
            
            </template>
                </v-treeview>
                </v-col>
       </v-row>
      
    </v-col>
  </v-row>
  
          
</v-card>
</v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import {mapActions} from 'vuex'

  export default {
      props:["cat"],
    data () {
      return {
        parentName:"",
        catlist:[],
        newcatactive:[],
        catactive:[],
        categories:[]
      }
    },
    mounted(){
      
        
    },
    computed:{
      ...mapGetters({
        treeviewCatItems:'treeviewCatDb'
      })
    },
    methods: {
      makeCatPrincipal(){
        var id = 'cat1'
        console.log('make cat principale')
               
            var size = this.$store.state.catdb.length
            console.log('size : ',size)
            var pos=1

            for(var i=1;i<size;i++){
              if(this.$store.state.catdb[i].id!=id){continue}else{
                pos+=1
                id='cat'+pos
                i=0
              }
            }
            
            
            var cat = {
              'id':id,'name':this.cat[0].name,'desc':this.cat[0].desc,'children':[],childs:this.cat[0].childs,
              'parentid':'','qtyprod':this.cat[0].qtyprod,'invAlert':this.cat[0].invAlert,lvl:0
            }
            console.log('cat : ',cat)

           this.addCat(cat)
           var payload = {'id':this.cat[0].id,'newid':id,'catname':this.cat[0].name,'newpath':pos}
           this.modifProductCat(payload)
          this.deleteCat(this.cat[0])
          this.$emit('close')

      },
      changeParent(newcat){
          
        var parentid = newcat.id;
        
        var id = parentid+'-'+'sub1';     
        var childrens = newcat.childs;

        if(childrens>0){
                var pos=1
                var size = this.$store.state.catdb.length
           

            for(var i=0;i<size;i++){
              if(this.$store.state.catdb[i].id!=id){continue}else{
                pos+=1
                id=parentid+'-'+'sub'+pos
                i=0
              }
            }
            } 

            var cat = {
              'id':id,'name':this.cat[0].name,'desc':this.cat[0].desc,'children':[],childs:this.cat[0].childs,
              'parentid':parentid,'qtyprod':this.cat[0].qtyprod,'invAlert':this.cat[0].invAlert,'level':newcat.level+1
            }

            
            setTimeout(function () {

                this.addCat(cat)

            }.bind(this), 500);
            setTimeout(function () {
             // console.log('coucou : ',newcat)

                this.updateCatChildCount({'cat':newcat,'ammount':1})

            }.bind(this), 500);
            setTimeout(function () {

                var payload = {'id':this.cat[0].id,'newid':id,'catname':this.cat[0].name}
           this.modifProductCat(payload)

            }.bind(this), 500);
            setTimeout(function () {
              var cat = this.cat[0]
                this.deleteCat(cat)

            }.bind(this), 500);
            setTimeout(function () {
                
                this.$emit('close')

            }.bind(this), 500);
           
      },

      ...mapActions([
        'deleteCat',
        'updateCatChildCount',
        'addCat',
        'modifProductCat'
      ]),
        
    },
    }
</script>